import { BasketballEventType } from '@hefe/models';
import {
  FaBasketballBall,
  FaEye,
  FaPencilAlt,
  FaRunning,
  FaTasks,
} from 'react-icons/fa';
import { GiBasketballJersey, GiWhistle } from 'react-icons/gi';
import { MdEvent } from 'react-icons/md';

export const BasketballEventIcon = {
  GAME: FaBasketballBall,
  PRACTICE: FaRunning,
  JUDGE: FaPencilAlt,
  REFEREE: GiWhistle,
  VISOR: FaEye,
  JERSEYS: GiBasketballJersey,
  TASK: FaTasks,
  EVENT: MdEvent,
  DEFAULT: MdEvent,
};

export const getBasketballEventIcon = (type: BasketballEventType) => {
  switch (type) {
    case BasketballEventType.GAME:
      return BasketballEventIcon.GAME;
    case BasketballEventType.PRACTICE:
      return BasketballEventIcon.PRACTICE;
    case BasketballEventType.JUDGE:
      return BasketballEventIcon.JUDGE;
    case BasketballEventType.REFEREE:
      return BasketballEventIcon.REFEREE;
    case BasketballEventType.VISOR:
      return BasketballEventIcon.VISOR;
    case BasketballEventType.JERSEYS:
      return BasketballEventIcon.JERSEYS;
    case BasketballEventType.EVENT:
      return BasketballEventIcon.EVENT;
    default:
      return BasketballEventIcon.DEFAULT;
  }
};
